export const BookValidationScheema = (json) => {

    console.log("json", json);

    const MyPromise = new Promise((resolve, reject) => {
        var errorJson = {};

        if (json?.bookName === undefined || json?.bookName === '') {
            Object.assign(errorJson, { bookName: "Book name cannot be empty *" });
        }

        if (json?.status === undefined || json?.status === '') {
            Object.assign(errorJson, { status: "Selection of status is required *" });
        }

        resolve(errorJson);
    })
    return MyPromise;
}
